import React, { useEffect, useState } from 'react'
import $ from 'jquery'

export default function Project_issues() {
  const active_pro_name = localStorage.getItem('selected_project_name');
  const active_pro_id = localStorage.getItem('selected_project_id');
  const company_id = localStorage.getItem("mem_company_id");
  const user_id = localStorage.getItem("member_id");
  const user_name = localStorage.getItem("membername");

  const [showPopup, setShowPopup] = useState(false);
  const [issueeName, setIssueName] = useState('');
  const [issueeDetails, setissueeDetails] = useState('');
  const [listOfIssues, setListOfIssues] = useState([]);
  const [loadingIssue, setLoadingIssue] = useState(false);

  useEffect(() => {
    loadIssues();
  }, []);

  function loadIssues() {
    setLoadingIssue(true);

    var obj = {
      pro_id: active_pro_id,
      com_id: company_id
    };

    fetch('getAllProjectIssue.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(res => res.json())
      .then(data => {
        setListOfIssues(data || []);
        setLoadingIssue(false);
      })
      .catch(err => {
        console.log(err);
        setLoadingIssue(false);
      });
  }

  function openIssueform() {
    setShowPopup(true);
  }

  function closeIssueForm() {
    setShowPopup(false);
  }

  function submitIssue() {
    if (!issueeName || !issueeDetails) {
      showAlert("Please fill all fields");
      return;
    }

    var obj = {
      company_id,
      project_id: active_pro_id,
      user_id,
      user_name:user_name,
      issue_name: issueeName,
      issue_details: issueeDetails
    };

    fetch('submitProjectIssue.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(res => res.text())
      .then(data => {
        if (data === "success") { 
          showAlert("Issue submited successfully");         
          setIssueName('');
          setissueeDetails('');
          setShowPopup(false);
          loadIssues();
        } else {
          showAlert("Failed to submit issue");
        }
      });
  }

   function showAlert(msg) {
      $('#alertpop').css('display', 'block');
      $('#alert_text').text(msg);
    }
  
    function closeAlert() {
      $('#alertpop').css('display', 'none');
      $('#alert_text').text('');
    }

  function solveIssue(issue_id) {
    fetch('solveProjectIssue.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({ issue_id })
    })
      .then(res => res.text())
      .then(data => {
        if (data === "success") {
          loadIssues();
        }
      });
  }

  return (
    <div>
      <div className='topbar_menu'>
        <button className='member_button addmembtn' onClick={openIssueform}>
          Add Issues
        </button>

        <p>Project name : {active_pro_name}</p>
        <p>Issues Log</p>
        <p>
          This page informs all team members about project issues.
        </p>
      </div>

      <div className='search_result_list'>
        {loadingIssue && <p>Loading issues...</p>}

        {!loadingIssue && listOfIssues.map((item) => (
          <div className='issuelist' key={item.id}>
            <h3>{item.issue_name}</h3>

            <span>
              <p>Submitted by : {item.user_name}</p>
            </span>

            <span>
              <p>Submitted on: {item.submitted_on}</p>
            </span>

            <p>{item.issue_details}</p>

            <span>
              <p>Status: {item.status}</p>
            </span>

            {item.status !== "Solved" && (
              <div className='vl_dsh_buttonholder'>
                <button
                  className='only_text'
                  onClick={() => solveIssue(item.id)}>
                  Solved
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {showPopup && (
        <div className="vl_dsh_popup_vis">
          <div className="section_pop_content">
            <button
              className="section_pop_clsoe"
              onClick={closeIssueForm}            >
              X
            </button>

            <h2>{active_pro_name}</h2>
            <p>Please give detail information about the issue.</p>

            <div className='section_pop_form'>
              <div className='section_fieldholder'>
                <label>Issue Name</label>
                <input
                  type="text"
                  value={issueeName}
                  onChange={(e) => setIssueName(e.target.value)}
                />

                <label>Issue Details</label>
                <textarea
                  value={issueeDetails}
                  onChange={(e) => setissueeDetails(e.target.value)}
                ></textarea>

                <div className='vl_dsh_buttonholder'>
                  <button onClick={submitIssue}>
                    Submit Issue
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
    </div>
  )
}